module.exports = __webpack_public_path__ + "static/United_States_Department_of_Defense_Seal-72443073cf4fb1a290ead86edcdfe115.svg";